import template from './promoCode.html';
import _ from 'lodash';
import './promoCode.scss';
import moment from 'moment';
import 'moment-timezone';

class PromoCodeController {
    /*@ngInject*/
    constructor(cartService, $rootScope, constants, dataContext, $q, activationService, $timeout, settingsDataService, $window) {
        this.cartService = cartService;
        this.$rootScope = $rootScope;
        this.constants = constants;
        this.settingsDataService = settingsDataService;
        this.dataContext = dataContext;
        this.$q = $q;
        this.activationService = activationService;
        this.$timeout = $timeout;
        this.$window = $window;
    }

    resetCouponStatus() {
        this.couponApplied = false;
        this.noCouponsFound = false;
    }

    //applies the coupon
    processCoupon() {
        this.isLoading = true;
        this.userCouponCount = 0;
        this.totalCouponCount = 0;
        this.resetCouponStatus();
        this.currentCoupon = undefined;

        let tempPromo = this.promoCode;
        this.dataContext.account.getCouponInfo(tempPromo)
            .then((result) => {
                this.currentCoupon = _.find(result.Data, coupon => {
                    return coupon.CouponCode.trim().toUpperCase() === tempPromo.trim().toUpperCase();
                });
                if (!_.isNil(this.currentCoupon)) {
                    // Check for user settings applicable coupons
                    if (_.includes(this.currentCoupon.Description, this.constants.coupon.userSettingGroups)) {
                        let couponName = _.replace(this.currentCoupon.Description, this.constants.coupon.userSettingGroups, ''); 
                        return this.dataContext.user.getUserInfo().then((userInfo) => {
                            if (userInfo.Settings) {
                                let couponSetting = _.find(userInfo.Settings,
                                    (setting) => {
                                        return setting.Name === couponName && setting.Value === 'True';
                                    });

                                if (couponSetting) {
                                    this.getCouponInfo(this.currentCoupon).then(() => {
                                        this.addCoupon();
                                    });
                                } else {
                                    this.noCouponsFound = true;
                                    this.isLoading = false;
                                    return this.$q.reject();
                                }
                            }
                        });
                    }
                    this.getCouponInfo(this.currentCoupon)
                        .then(() => {
                            this.addCoupon();
                        });
                } else {
                    this.noCouponsFound = true;
                    this.isLoading = false;
                    return this.$q.reject();
                }
            });
    }

    getCouponInfo(coupon) {
        //get total usage count of coupon       
        return this.dataContext.account.getCouponTotalUsage(coupon.CouponID)
            //get all orders attached to account
            .then((result) => {
                if (!_.isNil(result)) {
                    this.totalCouponCount = result.TotalUsage;
                    this.exceededMaxUsages = coupon.TotalUsage <= result.TotalUsage;
                }
                return this.dataContext.account.getOrders();
            })
            //check orders to see if user has already used coupon before
            .then((result) => {
                _.forEach(result.Data, (order) => {
                    if (_.get(order, 'CouponID', 0) === coupon.CouponID) {
                        this.userCouponCount++;
                    }
                });
                this.exceededMaxUsagesUser = coupon.PerCustomerLimit <= this.userCouponCount;
            });
    }

    //adds the coupon
    addCoupon() {
        this.cartService.addCoupon(this.promoCode, this.userCouponCount, this.totalCouponCount)
            .then(() => {
                this._processAfter();
            }).catch((ex) => {
                //TODO: add logging
            });
    }

    //removes the coupon
    removeCoupon() {
        this.cartService.removeCoupon()
            .then(() => {
                this._processAfter();
                this.resetCouponStatus();
                this.promoCode = '';
            }).catch((ex) => {
                //TODO: add logging
            });
    }

    getErrorMessage() {
        const couponEffectiveDate = _.get(this, 'currentCoupon.EffectiveDate', undefined);
        const couponExpireDate = _.get(this, 'currentCoupon.ExpireDate', undefined);
        if (!_.isNil(couponEffectiveDate) && (moment.tz(couponEffectiveDate, 'America/New_York') > moment().tz('America/New_York'))) {
            return 'This coupon is currently inactive. Please enter a valid code.';
        } else if (!_.isNil(couponExpireDate) && (moment.tz(couponExpireDate, 'America/New_York') < moment().tz('America/New_York'))) {
            return 'This coupon has expired. Please enter a valid code.';
        } else if (this.exceededMaxUsagesUser || this.exceededMaxUsages) {
            return 'This coupon has already been redeemed. Please enter a valid code.';
        } else {
            return 'This coupon is invalid. Please enter a valid coupon.';
        }
    }

    //update cart 
    _processAfter() {
        this.getCart();
        this.couponApplied = true;

        this.$rootScope.$broadcast('cartItemsChanged');
        this.$timeout(() => {
            this.isLoading = false;
        }, 1000);
    }
}

export default {
    template: template,
    bindings: {
        coupon: '<',
        getCart: '&'
    },
    controller: PromoCodeController
};